import { render, staticRenderFns } from "./PmauPrompts.vue?vue&type=template&id=3c22104e&scoped=true&"
import script from "./PmauPrompts.vue?vue&type=script&lang=js&"
export * from "./PmauPrompts.vue?vue&type=script&lang=js&"
import style0 from "./PmauPrompts.vue?vue&type=style&index=0&id=3c22104e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22104e",
  null
  
)

export default component.exports